export const filtersContainerStyling = isWebView => {
  return {
    container: {
      position: 'sticky',
      zIndex: 1000,
      top: isWebView ? 40 : 76
    }
  };
};
